/**
 * Shared field-category taxonomy (order + labels) for the field warehouse's
 * category_key. One source of truth used by the Field Library admin
 * (FieldLibrarySettingsPage) and the publish-node field selector (PublishConfig),
 * so the two never drift.
 */

export const CATEGORY_ORDER = [
  'identity', 'reference', 'dates', 'financial', 'location', 'terms', 'hr', 'line_items', 'custom',
];

export const CATEGORY_LABELS = {
  identity:   '🏢 Identity',
  reference:  '🔖 Reference',
  dates:      '📅 Dates',
  financial:  '💰 Financial',
  location:   '📍 Location',
  terms:      '📋 Terms',
  hr:         '👤 HR',
  line_items: '📊 Line Items',
  custom:     '⚙️ Custom',
};
